import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil, debounceTime } from 'rxjs';
import { CrudService } from 'src/app/services/crud.service';
import { AnalyticsModalComponent } from '../../new-my-videos/analytics-modal/analytics-modal.component';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-group-analytics',
  templateUrl: './group-analytics.component.html',
  styleUrl: './group-analytics.component.css'
})
export class GroupAnalyticsComponent {
  spinner: any = false;
  groupId: any;
  groupVideos: any[] = [];
  isAnalytics = false;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  page: number = 1;
  limit: number = 10;
  searchText: any;
  groupDetail: any;

  constructor(
    private activateRoute: ActivatedRoute,
    private apiService: CrudService,
    private router: Router,
    private dialog: MatDialog,
    private dashboardService: DashboardService,
  ) {
    this.activateRoute.params.pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.groupId = res.id;

      if (this.groupId) {
        this.getGroupInfo();
        // this.getGroupVideos();
      } else {
        this.router.navigate(['/']);
      }
    });

    this.dashboardService.getSearchTerm
    .pipe(takeUntil(this._unsubscribeAll), debounceTime(1000))
    .subscribe((res) => {
        this.spinner = true
        this.searchText = res;
        this.getGroupVideos(true);
    });
  }

  getGroupInfo(){
    this.spinner = true
    this.apiService.getGroupDetail(this.groupId).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.groupDetail = res.data[0];
    })

  }

  getGroupVideos(reset = true) {
    if(reset) {
      this.spinner = true;
      this.page = 1;
      this.groupVideos = [];
    }
    this.apiService.getGroupAllContent(this.groupId, this.searchText, this.page, this.limit)
      .pipe(takeUntil(this._unsubscribeAll)).subscribe(success => {
        this.spinner = false;

        if (reset) {
          this.groupVideos = success.data;
        } else {
          for (const item of success.data) {
            this.groupVideos.push(item);
          }
        }
      })
  }

  onScroll() {
    ++this.page;
    this.getGroupVideos(false);
  }

  showAnalytics(data: any) {
    this.spinner = true;
    this.apiService.getTree(data?.contentData?._id).subscribe((success) => {

      if (!!!success.data?.URL) {
        success.data.basck = 'gt';
      } else {
        success.data.basck = 'videochart';
        success.data.imvd = 'ncs';
      }

      const dialogRef = this.dialog.open(AnalyticsModalComponent, {
        width: '100%',
        maxWidth: '1400px',
        panelClass: 'analytics-modal',
        height: 'auto',
        data: { topChoices: success.data, groupId: this.groupId }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
        }
      });
      this.spinner = false;
    });

  }

  routeToQnaireDashboard(id: any) {
    this.router.navigate(['/questionnaires-dashboard/'+  id], { queryParams: { groupId: this.groupId } });
  }
}
